import { render } from "./DataMigration.vue?vue&type=template&id=a93e69fe&scoped=true"
import script from "./DataMigration.vue?vue&type=script&lang=js"
export * from "./DataMigration.vue?vue&type=script&lang=js"

import "./DataMigration.vue?vue&type=style&index=0&id=a93e69fe&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93e69fe"]])

export default __exports__